import React from "react";
import { useParams } from "react-router-dom";
import Books from "./Books";
import BookIllustrations from "./BookIllustrations";
import BookList from "./BookList";
import BookIllustrationList from "./BookIllustrationList";
const Bibliography = (props) => {
  const { section, section_2, id } = useParams();
  const currentTab = () => {
    switch (section) {
      case "books":
        return !!id ? (
          <Books {...props} />
        ) : (
          <BookList {...props} />
        );
      case "book-illustrations":
        return !!id ? (
          <BookIllustrations {...props} />
        ) : (
          <BookIllustrationList {...props} />
        );
      default:
        return <Books {...props} />;
    }
  };
  return <div>{currentTab()}</div>;
};

export default Bibliography;
